import { OPEN_LOADER } from 'action-types';

export default function () {
  return {
    type: OPEN_LOADER,
  };
}
